/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'ordre croissant',
  'fabric.editor.headingLink.copied': 'Copié !',
  'fabric.editor.headingLink.copyAnchorLink': "Copier le lien vers l'en-tête",
  'fabric.editor.headingLink.copyAriaLabel': 'Copier',
  'fabric.editor.headingLink.descSortingLabel': 'ordre décroissant',
  'fabric.editor.headingLink.failedToCopy': 'Copie impossible',
  'fabric.editor.headingLink.noneSortingLabel': 'Néant',
  'fabric.editor.inlineComment.marker.end': 'fin du commentaire contextuel',
  'fabric.editor.inlineComment.marker.start': 'début du commentaire contextuel',
};
